import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from 'common/styles/breakpoints';

export const TopLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: var(--space-500);
  padding-bottom: var(--space-125);
  overflow-x: hidden;

  ${breakpoints.only.mobile} {
    padding-top: var(--space-100);
  }
`;

export const smDisplayCard = css`
  display: flex;
  margin-bottom: var(--space-400);
`;

export const itemStyles = css`
  max-width: var(--layout-width);
  scroll-snap-align: start;
  padding: 0 !important;
  border: none;
  pointer-events: none;
  --button-bg: var(--background-secondary) !important;
  --button-hover-bg: var(--control-minor) !important;
  --translate-distance: 0 !important;
`;

export const active = css`
  pointer-events: auto;
`;

export const promoCarouselWrapperStyles = css`
  width: 100vw;
  max-width: 1180px;
  margin: 0 auto;
  ${breakpoints.only.desktop} {
    width: 100%;
    max-width: 940px;
    padding: 0;
  }
  ${breakpoints.only.mobile} {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-right: var(--layout-gap);
    padding-left: var(--layout-gap);
  }
  [data-qa-carousel=''] {
    ${breakpoints.only.tablet} {
      padding: 0 calc((100vw - var(--layout-width) - 2 * var(--layout-gap)) / 2 + var(--layout-gap));
      scroll-padding: calc((100vw - var(--layout-width) - 2 * var(--layout-gap)) / 2 + var(--layout-gap));
    }
  }
`;
